import { call, put, takeLatest } from 'redux-saga/effects';

import * as appointmentActions from './appointmentActions.js';
import { updateAppointmentApiCall } from './appointmentAPI.js';

function* updateAppointmentSaga({ payload }) {
  try {
    const { data } = yield call(updateAppointmentApiCall, payload);
    yield put(appointmentActions.appointmentUpdateStore(data));
  } catch (error) {
    yield put(appointmentActions.appointmentUpdateError(error.Message ? error.Message : error.toString()));
  }
}

export function* appointmentWatcher() {
  yield takeLatest(appointmentActions.appointmentUpdateRequest.type, updateAppointmentSaga);
}
